module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mx-05c8d69783e68aaad2f439631db79616.svg";